import React from "react";
import styled from "styled-components";
import UnstyledSearchIcon from "../../../../lib/ui/search";

const Container = styled.div<{ cWidth: string; cHeight: string }>`
  width: ${(props) => props.cWidth};
  position: relative;
}`;

const SearchIcon = styled(UnstyledSearchIcon)`
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #84838d;
`;

const Input = styled.input<{ iHeight: string }>`
  border-radius: 8px;
  outline: 1px solid #dadce0;
  width: 100%;
  line-height: ${(props) => props.iHeight};
  border: none;
  box-sizing: border-box;
  padding: 0 0 0 50px;
  color: #5f6368;
  font-size: 16px;
  font-family: Inter, system-ui;
  transition: border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &::placeholder {
    opacity: 0.75;
  }

  &:focus {
    outline: 1px solid #949494;

    &::placeholder {
      opacity: 1;
    }
  }
`;

interface SearchBarProps {
  width?: string;
  height?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const SearchBar = (props: SearchBarProps) => {
  const {
    width = "100%",
    height = "42px",
    placeholder = "Search",
    value,
    onChange,
    className,
  } = props;

  return (
    <Container cWidth={width} cHeight={height} className={className}>
      <SearchIcon />
      <Input
        iHeight={height}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
    </Container>
  );
};

export default SearchBar;
